export const DONE_COLUMN_ID = 'done';

export const ARCHIVED_COLUMN_ID = 'archived';

export const DEFAULT_KANBAN_COLUMNS = Object.freeze([
    Object.freeze({ id: 'todo', label: 'To Do', order: 0 }),
    Object.freeze({ id: 'in-progress', label: 'In Progress', order: 1 }),
    Object.freeze({ id: 'review', label: 'Review', order: 2 }),
    Object.freeze({ id: DONE_COLUMN_ID, label: 'Done', order: 3 }),
]);

export const STALE_COLUMN_MESSAGE = 'That column is no longer on this board. Loading the latest version.';

export const MISSING_CARD_MESSAGE = 'That card is no longer on this board. Loading the latest version.';

export const sameColumns = (a, b) => a.length === b.length && a.every((col, index) => col.id === b[index].id && col.label === b[index].label);

export const isStaleColumnError = (error) => error?.response?.status === 400 && Array.isArray(error?.response?.data?.validColumnIds);

export const isMissingCardError = (error) => error?.response?.status === 404;

// A BugHerd board is mirrored onto this board, so there is nowhere to send someone.
export const externalBoardLink = (externalBoard) => {
    const { provider, url } = externalBoard || {};
    if (!provider || provider === 'bugherd' || !url) return null;
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
        return { href: parsed.href, host: parsed.hostname };
    } catch {
        return null;
    }
};
